module.exports = __webpack_public_path__ + "img/LBNorm_Sashe_Gray_1280x1010.d9a41e85.jpg";